<ion-item>
    <ion-grid>
        <ion-row>
            <ion-col> <!-- Mejorar interfaz -->
                <div class = "circle-div" [class.selected] = "selected"></div>
            </ion-col>
            <ion-col>
                {{ memberFeeName }}
            </ion-col>
        </ion-row>
    </ion-grid>    
</ion-item>